// ④/C1 — تمييز العدد العربي: دالة واحدة لكل «رقم + اسم معدود».
// الصيغ: [مفرد، مثنى، جمع (3–10)، تمييز منصوب (11–99)].
export const AR_COUNT_FORMS = {
  day: ["يوم", "يومان", "أيام", "يوماً"],
  week: ["أسبوع", "أسبوعان", "أسابيع", "أسبوعاً"],
  month: ["شهر", "شهران", "أشهر", "شهراً"],
  hour: ["ساعة", "ساعتان", "ساعات", "ساعة"],
  minute: ["دقيقة", "دقيقتان", "دقائق", "دقيقة"],
  customer: ["عميل", "عميلان", "عملاء", "عميلاً"],
  visit: ["زيارة", "زيارتان", "زيارات", "زيارة"],
  message: ["رسالة", "رسالتان", "رسائل", "رسالة"],
  invoice: ["فاتورة", "فاتورتان", "فواتير", "فاتورة"],
  order: ["طلب", "طلبان", "طلبات", "طلباً"],
  template: ["قالب", "قالبان", "قوالب", "قالباً"],
  employee: ["موظف", "موظفان", "موظفين", "موظفاً"],
};

const num = (n) => Number(n).toLocaleString("ar-SA-u-nu-latn");

export function arCount(n, forms) {
  const f = typeof forms === "string" ? AR_COUNT_FORMS[forms] : forms;
  const v = Math.abs(Math.trunc(Number(n) || 0));
  const [one, two, few, many] = f;
  if (v === 0) return `${num(0)} ${one}`;
  if (v === 1) return one;
  if (v === 2) return two;
  const r = v % 100;
  if (r >= 3 && r <= 10) return `${num(v)} ${few}`;
  if (r >= 11 && r <= 99) return `${num(v)} ${many}`;
  return `${num(v)} ${one}`;
}
